import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../core/services/api.service';
import { CityParkingCardAdvanceApprove } from '../../../../../core/models/coupon.model';
import { InputComponent } from '../../../../../tools/forms/input/input.component';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ToastService } from 'angular-toastify';

@Component({
  selector: 'app-coupon-parking-list',
  imports: [
    CommonModule,
    FormsModule,
    InputComponent,
    PssLoadingComponent
  ],
  templateUrl: './coupon-parking-list.component.html',
  styleUrl: './coupon-parking-list.component.css'
})
export class CouponParkingListComponent {
  couponsCard: CityParkingCardAdvanceApprove[] = [];
  filteredCouponsCard: CityParkingCardAdvanceApprove[] | null = null;
  searchCouponCode: string = '';

  // ✅ Pagination state
  currentPage = 1;
  pageSize = 10; // ค่าเริ่มต้น

  // ( Date format )
  endDate: string = new Date().toISOString().slice(0, 10);
  startDate: string = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  // Loading
  isLoading: boolean = false;

  // Modal
  isModalCreate: boolean = false;
  isModalSome: boolean = false;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getCardAdvancesApprove()
  }

  /* -------------------------------------------- Function --------------------------------------------*/

  /* --- Style --- */
  // Table Logic
  get filteredAndPaginatedData() {
    let data = this.couponsCard;

    // ถ้ามีการพิมพ์ค้นหา
    if (this.searchCouponCode) {
      const searchText = this.searchCouponCode.toLowerCase();

      data = data.filter(c =>
        // ✅ คอลัมน์ 1: ชื่อ (เช็ค null ด้วย || '')
        (c.name || '').toLowerCase().includes(searchText) ||

        // ✅ คอลัมน์ 2: ชื่อสถานที่
        (c.siteName || '').toLowerCase().includes(searchText) ||

        // ✅ คอลัมน์ 3: ประเภทบัตร
        (c.cardTypeName || '').toLowerCase().includes(searchText)
      );
    }

    // คำนวณ Pagination จาก data ที่กรองแล้ว
    const start = (this.currentPage - 1) * this.pageSize;
    return data.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    let data = this.couponsCard;

    if (this.searchCouponCode) {
      const searchText = this.searchCouponCode.toLowerCase();
      data = data.filter(c =>
        (c.name || '').toLowerCase().includes(searchText) ||
        (c.siteName || '').toLowerCase().includes(searchText) ||
        (c.cardTypeName || '').toLowerCase().includes(searchText)
      );
    }

    if (this.pageSize === 0) return 0;
    return Math.ceil(data.length / this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  // ✅ เพิ่มฟังก์ชันนี้ครับ: เปลี่ยนจำนวนแถวต่อหน้า
  onPageSizeChange(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.pageSize = Number(element.value);
    this.currentPage = 1; // รีเซ็ตกลับไปหน้าแรกทุกครั้งที่เปลี่ยนจำนวนแถว
  }

  /* --- Function --- */
  // Modal
  openCreateModal() {
    this.isModalCreate = true
  }

  /* --- CardAdvancesApprove --- */
  // ( Search )
  onSearchCouponCode(value: string) {
    this.searchCouponCode = value;
    this.currentPage = 1; // รีเซ็ตหน้าเมื่อพิมพ์ค้นหา
  }

  onClickSearch() {
    if (!this.startDate || !this.endDate) {
      this.toast.warn('กรุณาเลือกช่วงวันที่');
      return
    }
    this.getCardAdvancesApprove();
  }

  navigateToDetailById(id: number) {
    this.router.navigate([`/coupon-parking-list-details/${id}`]);
  }
  onSaveModal() {
    this.isModalSome = false
  }
  onSaveCreateModal() {
    this.isModalSome = false
  }

  /* -------------------------------------------- API --------------------------------------------*/
  async getCardAdvancesApprove() {
    this.apiService.getCardAdvancesApprove(this.startDate, this.endDate).subscribe({
      next: (res) => {
        //console.log('Response getCoupon :', res);
        const dateStart = new Date(this.startDate);
        if (res.length == 0
          && dateStart.getDate() != new Date().getDate() - 7
          && dateStart.getMonth() == new Date().getMonth()
          && dateStart.getFullYear() == new Date().getFullYear()) {
          this.toast.warn('ไม่พบข้อมูล');
        }
        this.couponsCard = res;
        this.isLoading = false;
        // รีเซ็ตหน้าเมื่อโหลดข้อมูลใหม่
        this.currentPage = 1;
      },
      error: (err) => {
        console.error('Error fetching card advance:', err);
        this.toast.error('Error fetching card advance');
        this.isLoading = false;
      }
    });
  }
}